import { useCallback, useEffect } from 'react';

type FbqFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
};

declare global {
  interface Window {
    fbq?: FbqFunction;
    _fbq?: FbqFunction;
    __metaPageViewTracked?: boolean;
    __metaViewContentTracked?: boolean;
  }
}

const PIXEL_ID = '931237132907425';

type MetaPixelEventData = Record<string, string | number | boolean>;

export function useMetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (!window.fbq) {
      const fbq = ((...args: unknown[]) => {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
          return;
        }
        fbq.queue.push(args);
      }) as FbqFunction;
      fbq.queue = [];
      window.fbq = fbq;
      window._fbq = fbq;

      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }

    window.fbq('init', PIXEL_ID);
    if (!window.__metaPageViewTracked) {
      window.fbq('track', 'PageView');
      window.__metaPageViewTracked = true;
    }
  }, []);

  const trackEvent = useCallback((eventName: string, data?: MetaPixelEventData) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', eventName, data);
    }
  }, []);

  return { trackEvent };
}
